import $ from 'jquery';
import Mustache from 'mustache';
import CSRLabelModel from 'components/csrFactoryMap/models/CSRLabelModel';
import templateFactoryDetail from './templates/factorydetail.html';
import EventDispatcher from 'components/csrFactoryMap/utils/EventDispatcher';
import { gsap, Power0, Power2, CSSPlugin } from 'gsap/all';

gsap.registerPlugin(Power0, Power2, CSSPlugin);

export default class CSRDetailFactoryView extends EventDispatcher {
  constructor(options) {
    super(options);
    this.el = options.el;
    this.$el = $(this.el);
    this.model = options.model;
    this.isStatic = options.isStatic;
    this.initialize(options.skipAnimation);
  }

  initialize(skipAnimation) {
    this.createTemplate();
    this.cacheSelectors();
    this.transitionIn(skipAnimation);
    this.setupEventListeners();
  }

  destroy(skipAnimation) {
    this.removeEventListeners();
    if (skipAnimation) {
      this.clearContent();
    } else {
      this.transitionOut(() => this.clearContent());
    }
    this.templateFactoryDetail = null;
  }

  createTemplate() {
    this.model.data.labels = CSRLabelModel.getData();
    this.model.data.hasLinks = this.model.data.links.length > 0;
    this.templateFactoryDetail = Mustache.render(templateFactoryDetail, this.model.data);
    this.renderTemplate(this.templateFactoryDetail, true);
  }

  renderTemplate(template, noAnimation) {
    this.scrollToTop();
    this.clearContent();
    this.el.insertAdjacentHTML('afterbegin', template);
    if (!noAnimation) {
      this.cacheSelectors();
      gsap.fromTo(
        this.ui.detail,
        { duration: 0.4, opacity: 0 },
        { duration: 0.4, opacity: 1, ease: Power0.easeNone }
      );
    }
  }

  transitionOut(callback) {
    gsap.to(this.el, {
      duration: 0.3,
      x: -350,
      ease: Power2.easeInOut,
      clearProps: 'x',
      onComplete: callback,
    });
  }

  transitionIn(skipAnimation) {
    const tl = gsap.timeline();
    if (!skipAnimation) {
      tl.fromTo(this.el, { duration: 0.5, x: -350 }, { x: 0, ease: Power2.easeInOut });
    }
    tl.fromTo(
      this.ui.detail,
      { duration: 0.3, opacity: 0 },
      { opacity: 1 },
      skipAnimation ? 0.2 : 0.55
    );
  }

  scrollToTop() {
    const scroll = { y: window.scrollY };
    gsap.to(scroll, { duration: 0.5, y: 0, onUpdate: () => window.scrollTo(0, scroll.y) });
  }

  clearContent() {
    while (this.el.firstChild) {
      this.el.removeChild(this.el.firstChild);
    }
  }

  cacheSelectors() {
    this.ui = {
      detail: this.el.querySelectorAll('.js-detail')[0],
    };
  }

  setupEventListeners() {
    if (!this.isStatic) {
      this.$el.on('click', '.js-detail-back', this.onBackClicked.bind(this));
    }
  }

  removeEventListeners() {
    this.$el.off();
  }

  onBackClicked(event) {
    event.preventDefault();

    if (this._detailActive) {
      this._detailActive = false;
      this.renderTemplate(this.templateFactoryDetail);
    } else {
      this.trigger('csrmap:navigate:back');
    }
  }
}
